import styled from 'styled-components';
import { GhostButton } from 'ui/button';
import { TagGroup } from 'ui/tags';
import { CollapsibleContent } from 'ui/collapsibleContent';
import { spacing, colors, caption } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const PREVIEW_WIDTH = 60;

export const HorizontalFlex = styled.div`
  display: flex;
  align-items: center;
`;

export const CollapsibleNameCell = styled(HorizontalFlex)`
  justify-content: space-between;
  max-width: 100%;
  overflow: hidden;
`;

export const Content = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  /** width minus 48px for arrow button and 8px for margin */
  max-width: calc(100% - ${pxToRem(56)});
`;

export const Details = styled.div`
  /** gets rid of weird padding inside of tooltips */
  [data-test='tooltip-trigger'] {
    border: none;
    padding: 0;
  }
  [data-test='tag-group'] {
    display: inline-flex;
  }
  [data-test='tag-group-content-wrapper'] {
    display: inline-flex;
    flex-wrap: wrap;
  }
`;

export const PrimaryCaption = styled.span`
  ${caption}
  color: ${colors.textPrimary};
`;

export const SecondaryCaption = styled(PrimaryCaption)`
  color: ${colors.textSecondary};
`;

export const Medium = styled(SecondaryCaption)`
  padding-right: ${spacing.half};
`;

export const StyledTagGroup = styled(TagGroup)`
  display: inline;
`;

export const IconWrapper = styled.span`
  display: inline-block;

  /** this aligns the svgs */
  vertical-align: sub;
  padding-right: ${spacing.half};

  [data-test='tooltip'] {
    display: inline-block;
  }
`;

export const StyledCollapsibleContent = styled(CollapsibleContent)`
  grid-column: 2 / span 1;
  grid-row: 2 / span 1;
`;

export const StyledGridContainer = styled.div`
  :first-child {
    padding-top: ${spacing.plusHalf};
  }
`;

export const CollapsibleItem = styled.div`
  ${caption}
  color: ${colors.textPrimary};
  display: grid;
  grid-template-columns: ${pxToRem(108)} auto;
  padding-bottom: ${spacing.half};
`;

export const ArrowButton = styled(GhostButton)`
  cursor: pointer;
  margin-right: ${spacing.quarter};
`;

export const WorkflowNodeEntry = styled.div`
  padding-bottom: ${spacing.half};
`;
